export default {"src":"/_next/static/media/background.52e647ba.svg","height":600,"width":700,"blurWidth":0,"blurHeight":0};